import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import athenaQuery from 'assets/dashboard/athenaQuery.png';
import ListAthenaCrudRequestDashboard from './listAthenaRequest';

export const ATHENA_DASHBOARD_RESOURCES = {
	listAthenaCrudRequest: 'listAthenaCrudRequest'
};

export const URL = {
	[ATHENA_DASHBOARD_RESOURCES.listAthenaCrudRequest]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.athenaDashboard}/${ATHENA_DASHBOARD_RESOURCES.listAthenaCrudRequest}`
};

export const LABEL = {
	[ATHENA_DASHBOARD_RESOURCES.listAthenaCrudRequest]: 'Request List'
};

export const COMPONENT = {
	[ATHENA_DASHBOARD_RESOURCES.listAthenaCrudRequest]: ListAthenaCrudRequestDashboard
};

export const GET_ACTION = {
	[ATHENA_DASHBOARD_RESOURCES.listAthenaCrudRequest]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.athenaDashboard].listAthenaCrudRequest
};

export const IMAGE_SOURCE = {
	[ATHENA_DASHBOARD_RESOURCES.listAthenaCrudRequest]: athenaQuery
};

export enum EAthenaDashboardURL {
	APPROVE_AND_PROCESS_ATHENA_CRUD_REQUEST = '/dashboard/approveAthenaCrudRequest/athenaDashboard-requestList-approveAthenaCrudRequest',
	REJECT_ATHENA_CRUD_REQUEST = '/dashboard/rejectAthenaCrudRequest/athenaDashboard-requestList-rejectAthenaCrudRequest',
	CREATE_ATHENA_CRUD_REQUEST = '/dashboard/createAthenaCrudRequest/athenaDashboard-requestList-createAthenaCrudRequest',
	LIST_ATHENA_CRUD_REQUEST = '/dashboard/listAthenaCrudRequest/athenaDashboard-requestList-listAthenaCrudRequest',
	GET_ATHENA_CRUD_REQUEST_BY_ID = '/dashboard/getAthenaCrudRequestDetails/athenaDashboard-requestList-getAthenaCrudRequestDetails',
	UPDATE_ATHENA_CRUD_REQUEST = '/dashboard/updateAthenaCrudRequest/athenaDashboard-requestList-updateAthenaCrudRequest',
	GET_ATHENA_CRUD_REQUEST_VERSION_HISTORY = '/dashboard/getAthenaCrudRequestVersionHistory/athenaDashboard-requestList-getAthenaCrudRequestVersionHistory'
}

export enum EResponseCode {
	SUCCESS = 200
}

export const EAthenaDashboardResources = {
	REQUEST_LIST: 'requestList'
};
